import { websiteConfig } from '@/config/website';
import { cn } from '@/lib/utils';

export function Logo({ className }: { className?: string }) {
  const name = websiteConfig.metadata?.name ?? 'App';
  const logoLight = websiteConfig.metadata?.images?.logoLight ?? '/logo.png';

  return (
    <img
      src={logoLight}
      alt={`${name} logo`}
      className={cn('size-10 rounded-md', className)}
      width={40}
      height={40}
      decoding="async"
    />
  );
}
